import * as React from 'react';
import { styled } from '@glitz/react';
import { ArticleCard } from './ArticleCard';
import { useMatchDevice } from '@avensia/excite/match-device-width';
import { theme } from 'nordicnest/shared/theme';
import { Carousel as CarouselComponent, type DeviceSettingType, useCarousel } from 'webapp/components/Carousel';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';

type PropType = {
  list: NordicNest.Api.ArticleListItemApiModel[];
  productId: string;
};

const visibleCount: DeviceSettingType = { mobile: 1, tablet: 2, desktop: 3 };
const nextSlideFactor: DeviceSettingType = { mobile: 1.5, tablet: 1.5, desktop: 1.5 };

export const ArticleListing = styled(({ list, productId }: PropType) => {
  const deviceMatch = useMatchDevice();
  const carousel = useCarousel(`articles-${productId}`, { align: 'start' });
  const { isDesktop } = deviceMatch;

  return (
    <Base>
      <Carousel
        visibleCount={visibleCount}
        gap={isDesktop ? theme.sharedSpacing.xl : theme.sharedSpacing.m}
        containerDecorator={marginDecorator}
        showNextSlideFactor={nextSlideFactor}
        {...carousel}
      >
        {list.map(article => (
          <ArticleCard key={article.url} {...article} />
        ))}
      </Carousel>
    </Base>
  );
});

const Base = styled.div();

const Carousel = styled(CarouselComponent, {
  width: '100%',
});

const marginDecorator = styled(
  createMaxSmallViewportDecorator({
    margin: { x: t => t.sharedSpacing.m },
  }),
);
